import { SalesChannelCampaignListPage } from "@/features/sales-channel-campaign/pages/SalesChannelCampaignListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/sales-channel-campaign/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["marketplace_campaigns.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCampaignListPage,
});
